import {useEffect, useMemo, useState} from 'react'
import fscreen from 'fscreen'
import {isApp, isMobile} from "@/helpers";
import EventEmitter2 from "eventemitter2";

declare global {
	interface Window {
		setFullscreen: (value?: boolean) => void
		toggleFullscreen: () => void
	}
}

const eventEmitter = new EventEmitter2()
const FULLSCREEN_CHANGE = 'fullscreenchange'

export const isFullscreenEnabled = isApp() ? !isMobile : fscreen.fullscreenEnabled
export let isFullscreen = isApp() ? false : !!fscreen.fullscreenElement

export const setFullscreen = async (value = false) => {
	if (!isFullscreenEnabled) {
		return
	}
	try {
		isFullscreen = value
		if (isApp() && (window as any)?.flutter_inappwebview?.callHandler) {
			(window as any)?.flutter_inappwebview?.callHandler('setFullscreen', value)
		} else {
			value ? !fscreen.fullscreenElement && await fscreen.requestFullscreen(document.documentElement) : !!fscreen.fullscreenElement && await fscreen.exitFullscreen()
		}
		eventEmitter.emit(FULLSCREEN_CHANGE, value)
	} catch (_e) {
		// do nothing
	}
}

export const toggleFullscreen = async () => setFullscreen(!isFullscreen)

window.setFullscreen = setFullscreen
window.toggleFullscreen = toggleFullscreen

export const useFullscreen = () => {
	const [fullscreen, _setFullscreen] = useState(isFullscreen)

	useEffect(() => {
		const handleFullscreenChange = () => {
			void setFullscreen(!!fscreen.fullscreenElement)
		}

		fscreen.addEventListener(FULLSCREEN_CHANGE, handleFullscreenChange)
		return () => {
			fscreen.removeEventListener(FULLSCREEN_CHANGE, handleFullscreenChange)
		}
	}, [])


	useEffect(() => {
		const callback = (value = false) => {
			_setFullscreen(value)
		}
		eventEmitter.on(FULLSCREEN_CHANGE, callback)
		return () => {
			eventEmitter.off(FULLSCREEN_CHANGE, callback)
		}
	}, [_setFullscreen]);

	return useMemo(() => ({
		isFullscreen: fullscreen,
		isFullscreenEnabled,
		setFullscreen,
		toggleFullscreen
	}), [fullscreen])
}
